
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexr_T8UTm_459rC1akge_45ePsYd8uvvYVhX_45XS_YGX8jF6ckMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/index.vue?macro=true";
import { default as login_YBRpBl_J3gJhkIi2Hr452Q4YGXlmuQ3_hDO_45EpdqdoMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/login.vue?macro=true";
import { default as _91_46_46_46all_933vgCWBHjaFD9iwBFv5zaMz6iv2UIxhG5eMC2rPs169UMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/[...all].vue?macro=true";
import { default as index1UL5wjq9r9uT0PyZ4_45IGHvOvSYIT1LLVriBiHEjugdcMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/index.vue?macro=true";
import { default as forgot_45passwordII4C5Vq_45D_45Vp4OIMHr98yQWfMPEIH6vQWrfSlUmWD3EMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/forgot-password.vue?macro=true";
import { default as new6qhn7k55KLMwwpJksVgISTI9iCb4gAvoWGwXW3Qa9PYMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/new.vue?macro=true";
import { default as indexTpmjkQQ8c_M3j3qTwz7540unPhWlJjgqjQ0NOzBvecQMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/index.vue?macro=true";
import { default as _91slug_93oPeQHWI1FhJUSElqM4kjgSHGp_45Y85AOducodcejq5_45YMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/edit/[slug].vue?macro=true";
import { default as _91slug_93JO7H3P0qXCb3ysjAMsrnyoKXAiAW_MiZW86hf9ZfrqUMeta } from "/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/view/[slug].vue?macro=true";
export default [
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/index.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: login_YBRpBl_J3gJhkIi2Hr452Q4YGXlmuQ3_hDO_45EpdqdoMeta || {},
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: login_YBRpBl_J3gJhkIi2Hr452Q4YGXlmuQ3_hDO_45EpdqdoMeta || {},
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/login.vue")
  },
  {
    name: "all___fr",
    path: "/fr/:all(.*)*",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[...all].vue")
  },
  {
    name: "all___en",
    path: "/:all(.*)*",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[...all].vue")
  },
  {
    name: "appId___fr",
    path: "/fr/:appId()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/index.vue")
  },
  {
    name: "appId___en",
    path: "/:appId()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/index.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45passwordII4C5Vq_45D_45Vp4OIMHr98yQWfMPEIH6vQWrfSlUmWD3EMeta || {},
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/forgot-password",
    meta: forgot_45passwordII4C5Vq_45D_45Vp4OIMHr98yQWfMPEIH6vQWrfSlUmWD3EMeta || {},
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/forgot-password.vue")
  },
  {
    name: "appId-category-new___fr",
    path: "/fr/:appId()/:category()/new",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/new.vue")
  },
  {
    name: "appId-category-new___en",
    path: "/:appId()/:category()/new",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/new.vue")
  },
  {
    name: "appId-category___fr",
    path: "/fr/:appId()/:category()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/index.vue")
  },
  {
    name: "appId-category___en",
    path: "/:appId()/:category()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/index.vue")
  },
  {
    name: "appId-category-edit-slug___fr",
    path: "/fr/:appId()/:category()/edit/:slug()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/edit/[slug].vue")
  },
  {
    name: "appId-category-edit-slug___en",
    path: "/:appId()/:category()/edit/:slug()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/edit/[slug].vue")
  },
  {
    name: "appId-category-view-slug___fr",
    path: "/fr/:appId()/:category()/view/:slug()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/view/[slug].vue")
  },
  {
    name: "appId-category-view-slug___en",
    path: "/:appId()/:category()/view/:slug()",
    component: () => import("/opt/actions-runner/_work/Apex/Apex/frontend/pages/[appId]/[category]/view/[slug].vue")
  }
]